import {CloseCircleOutlined} from '@ant-design/icons';
import {Button} from '@ds/components';
import {cn} from '@ds/helpers';

type FilterChipProps = {
  label: string;
  icon?: React.ReactNode;
  active?: boolean;
  onClick: () => void;
  onClear?: () => void;
};

const FilterChip: React.FC<FilterChipProps> = ({label, icon, active = false, onClick, onClear}) => {
  return (
    <Button
      size="sm"
      variant="outline"
      color="secondary"
      className={cn(
        'me-2 px-3',
        active &&
          'border-orange-deep bg-orange-wash text-orange-deep hover:border-orange-deep hover:bg-orange-wash hover:text-orange-deep'
      )}
      onClick={onClick}
    >
      <span className="flex items-center">
        {icon}
        <span>{label}</span>
      </span>
      {active && onClear ? (
        <span
          className="ms-1"
          onClick={(event) => {
            event.stopPropagation();
            onClear();
          }}
        >
          <CloseCircleOutlined className="text-body-lg" />
        </span>
      ) : null}
    </Button>
  );
};

export default FilterChip;
